module.exports = __webpack_public_path__ + "static/img/4003.f8dd8d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4003.png
// module id = 710
// module chunks = 0 1 12